import { faChevronDown, faChevronUp, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import ProfileMenu from './ProfileMenu';

const ProfileButton = () => {
	const [menuVisible, setMenuVisible] = useState(false);

	return (
		<>
			<div
				tabIndex={0}
				className="relative"
				onBlur={() => {
					setMenuVisible(false);
				}}
			>
				<div
					className="d-flex f-row profile-button pointer"
					onClick={() => {
						setMenuVisible(!menuVisible);
					}}
				>
					<FontAwesomeIcon icon={faUser} />
					{!menuVisible && <FontAwesomeIcon icon={faChevronDown} />}
					{menuVisible && <FontAwesomeIcon icon={faChevronUp} />}
				</div>
				<ProfileMenu
					visible={menuVisible}
					onClickUrl={() => {
						setMenuVisible(false);
					}}
				/>
			</div>
		</>
	);
};

export default ProfileButton;
